import { getUserLocale } from 'get-user-locale';
import { defaultLocale, supportedLocaleList } from 'config/locale';
import { ApplicationLocale } from 'types/intl';

/**
 * Get current browser locale
 */
export const getBrowserLocale = (): ApplicationLocale => {
  // Detect currently selected browser locale
  const locale = getUserLocale() as ApplicationLocale;

  // Ensure a valid locale is used as a fallback if an invalid one is currently specified
  return supportedLocaleList.includes(locale) ? locale : defaultLocale;
};
